import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash';
import { Heading } from 'components/Typography';

export const SupportCategoryHero = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  return (
    <div className="relative rounded-md p-32 bg-orchid-100 md:p-40 bg-cover bg-center min-h-[202px] flex justify-center items-center mb-40">
      <div>
        <Heading level="h6" className="text-center mb-24">
          {t('support.category.hero.heading')}
        </Heading>

        <Heading level="h2" className="text-center">
          {capitalize(name)}
        </Heading>
      </div>
    </div>
  );
};
